import { call, put, takeLatest } from 'redux-saga/effects';
import * as T from './appTokenTypes';
import * as actions from './appTokenActions';
import { validateAppTokenApi } from './appTokenApi';

function* validateAppTokenSaga() {
  try {
    const valid: boolean = yield call(validateAppTokenApi);
    yield put(actions.validateAppTokenSuccess(valid));
  } catch (error: any) {
    yield put(actions.validateAppTokenFailure(error?.message || 'App token validation failed'));
  }
}

export default function* appTokenSaga() {
  yield takeLatest(T.VALIDATE_APP_TOKEN_REQUEST, validateAppTokenSaga);
}
